module.exports = __webpack_public_path__ + "img/0_CNE Light.533c7344.png";